import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { InjectorInstance } from './global/global.service';

@Injectable({
    providedIn: 'root'
})
export class UtilitiesDate {

    static datePipe: DatePipe;

    constructor() {

    }

    static get birthDateYearRange() {
        const year = moment().year();
        return `${year - 150}:${year}`;
    }

    public static parse(date: string): Date {
        return new Date(date);
    }
    public static formatDate(date: string | Date, format: string = null, timeZone: string = null): string {
        UtilitiesDate.datePipe = UtilitiesDate.datePipe || InjectorInstance.get(DatePipe);

        const datePipe = UtilitiesDate.datePipe;

        if (!date) {
            return null;
        } else if (typeof date === 'string') {
            return datePipe.transform(date, format || 'MM/dd/yyyy', timeZone);
        } else if (typeof date.getMonth === 'function') {
            return datePipe.transform(date, format || 'MM/dd/yyyy');
        }

        return null;
    }

    static getDateString(date: string): string {
        const dateMoment = moment(date, 'YYYY-MM-DD HH:mm');
        const utcDate = moment.utc(dateMoment.format('YYYY-MM-DD HH:mm')).toDate();
        return utcDate.toLocaleString("en-US", { timeZone: "America/New_York" });
    }

    static getDate(date: Date | string): Date {
        let momentValue = moment(date);
        const dateMoment = moment(momentValue, 'YYYY-MM-DD HH:mm');
        return moment.utc(dateMoment.format('YYYY-MM-DD HH:mm')).toDate();
    }

    static getLocalDate(date: Date | string) {
        return moment(moment(date).local().format('YYYY-MM-DD HH:mm'));
    }

}
